import { acquireIdToken } from '../../authentication-context/tokenBroker';
import store from '../../store';

export const getCurrentUser = () => JSON.parse(localStorage.getItem('user') || '{}');

export const getToken = () => {
  const { token } = getCurrentUser();

  return token || '';
};

export const getAuthToken = async ({ forceRefresh = false } = {}) => {
  const token = await acquireIdToken({ forceRefresh });
  return token || '';
};

export const login = (userDetails = {}) => {
  localStorage.setItem('user', JSON.stringify(userDetails));
  store.dispatch({
    type: 'SESSION:SET_IS_LOGGED_IN',
    payload: {
      value: true,
      email: userDetails.email,
      clasArDashboard: userDetails?.clasArDashboard,
    },
  });
  store.dispatch({
    type: 'SUPPORT:DASHBOARD_NAV_OPEN',
    payload: { isOpen: true },
  });
};

export const logout = () => {
  store.dispatch({
    type: 'SESSION:SET_IS_LOGGED_IN',
    payload: {
      value: false,
    },
  });

  // Restoring Expandable SideBar To Default State
  store.dispatch({
    type: 'SUPPORT:DASHBOARD_NAV_OPEN',
    payload: { isOpen: false },
  });
  store.dispatch({
    type: 'SUPPORT:STATEMENT_NAV_OPEN',
    payload: { isOpen: false },
  });
  store.dispatch({
    type: 'SUPPORT:GL_CONFIGURATION_NAV_OPEN',
    payload: { isOpen: false },
  });
  store.dispatch({
    type: 'SUPPORT:JOURNALS_NAV_OPEN',
    payload: { isOpen: false },
  });

  // reset the dropdown value
  store.dispatch({
    type: 'SUPPORT:SET_OPI_VALUE',
    payload: 1,
  });
  // reset the serach string
  store.dispatch({
    type: 'SUPPORT:SET_SEARCH_STRING',
    payload: { value: '' },
  });

  // Reset set loading to display login.
  store.dispatch({
    type: `APPEARANCE:SET_LOADING`,
    payload: {
      value: false,
    },
  });

  // This resets two state variables.
  // 1. policies
  // reason: Policies of previousy logged in user should not be reused for new user.
  // 2. sidebar navItems
  // reason: All the changed content for the previousy logged in user should not be reused.
  // Eg: isOpen property
  store.dispatch({ type: 'SUPPORT:RESET_STATE', payload: { value: {} } });

  localStorage.removeItem('user');
};

export const getClasArDashboard = () => {
  const { clasArDashboard } = getCurrentUser();
  return clasArDashboard;
};
